import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Collapse, Pagination } from "react-bootstrap";
import { accountService } from '../../_services';

function List({ match }) {
    const { path } = match;
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pageSize] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        accountService.getAll({ page, pageSize, search }).then(x => {
            setUsers(x.items);
            setTotalPages(x.totalPages);
            setLoading(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }, [page, pageSize, search]);

    function deleteUser(id) {
        setUsers(users.map(x => {
            if (x.id === id) { x.isDeleting = true; }
            return x;
        }));
        accountService.delete(id).then(() => {
            setUsers(users => users.filter(x => x.id !== id));
        });
    }

    function handleSearchChange(e) {
        setSearch(e.target.value);
        setPage(1);
    }

    function getPageNumbers(current, total, window = 2) {
        const pages = [];
        const start = Math.max(2, current - window);
        const end = Math.min(total - 1, current + window);

        pages.push(1);
        if (start > 2) {
            pages.push('start-ellipsis');
        }
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        if (end < total - 1) {
            pages.push('end-ellipsis');
        }
        if (total > 1) {
            pages.push(total);
        }
        return pages;
    }

    return (
        <div>
            <div className="card-header header-admin">
                <h1 className="bold-tx">Manage Users</h1>
                <h5>All users from secure (admin only) api end point:</h5>
            </div>
            <div className="card-body">
                <Collapse in={true}>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search users..."
                            value={search}
                            onChange={handleSearchChange}
                        />
                    </div>
                </Collapse>
            </div>
            {totalPages > 1 && (
                <Pagination className="justify-content-center">
                    <Pagination.Prev
                        onClick={() => setPage(page - 1)}
                        disabled={page === 1}
                        hidden={page === 1}
                    />
                    {getPageNumbers(page, totalPages, 2).map((p, index) =>
                        typeof p === 'number' ? (
                            <Pagination.Item
                                key={p}
                                active={p === page}
                                onClick={() => setPage(p)}
                            >
                                {p}
                            </Pagination.Item>
                        ) : (
                            <Pagination.Ellipsis key={p + '-' + index} disabled />
                        )
                    )}
                    <Pagination.Next
                        onClick={() => setPage(page + 1)}
                        disabled={page === totalPages}
                    />
                </Pagination>
            )}
            <div>
                {/*<Link to={`${path}/add`} className="btn btn-sm btn-success mb-2">Add User</Link> */}
                <Table className="table table-striped" responsive="sm">
                    <thead>
                        <tr>
                            <th className="admin-btm-bdrline">Name</th>
                            <th className="admin-btm-bdrline">Email</th>
                            <th className="admin-btm-bdrline">Role</th>
                            <th className="admin-btm-bdrline">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    <span className="spinner-border spinner-border-lg align-center"></span>
                                </td>
                            </tr>
                        ) : users.length > 0 ? (
                            users.map(user => (
                                <tr className="admin-top-bdrline" key={user.id}>
                                    <td>{user.title} {user.firstName} {user.lastName}</td>
                                    <td>{user.email}</td>
                                    <td>{user.role}</td>
                                    <td>
                                        <Link to={`${path}/edit/${user.id}`} className="btn btn-sm btn-primary mr-1 user-edit-btn">Edit</Link>
                                        <br />
                                        <button onClick={() => deleteUser(user.id)} className="btn btn-sm btn-danger user-delete-btn" disabled={user.isDeleting}>
                                            {user.isDeleting
                                                ? <span className="spinner-border spinner-border-sm"></span>
                                                : <span>Delete</span>
                                            }
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">No users found</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                {totalPages > 1 && (
                    <Pagination className="justify-content-center">
                        <Pagination.Prev
                            onClick={() => setPage(page - 1)}
                            disabled={page === 1}
                            hidden={page === 1}
                        />
                        {getPageNumbers(page, totalPages, 2).map((p, index) =>
                            typeof p === 'number' ? (
                                <Pagination.Item
                                    key={p}
                                    active={p === page}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </Pagination.Item>
                            ) : (
                                <Pagination.Ellipsis key={p + '-' + index} disabled />
                            )
                        )}
                        <Pagination.Next
                            onClick={() => setPage(page + 1)}
                            disabled={page === totalPages}
                        />
                    </Pagination>
                )}
            </div>
            <h3 className="card-header admin-top-bdrline">
                <Link to={`/admin`} className="btn btn-link">Back</Link>
            </h3>
        </div>
    );
}

export { List };